export enum SubmissionDefaultStatus {
  open = 'OPEN',
  inProgress = 'IN_PROGRESS',
  closed = 'CLOSED',
}

export type SubmissionStatus = SubmissionDefaultStatus | string;
